import React, { forwardRef, useImperativeHandle, useRef, useMemo } from 'react';
import { GenericSettingsPane, GenericSettingsPaneHandle } from './GenericSettingsPane';
import { PaneHandle, PaneProps } from '../accountParameter.types';
import { useStoreState } from '../../../../models/hooks';
import { useTranslation } from 'react-i18next';

export const InterviewsPane = forwardRef<PaneHandle, PaneProps>(({ onSave, setDirty, showActions }, ref) => {
  const genericPaneRef = useRef<GenericSettingsPaneHandle>(null);
  const account = useStoreState((state) => state.app.accounts);
  const { t } = useTranslation('accountParameter');

  useImperativeHandle(ref, () => ({
    save: () => genericPaneRef.current?.save(),
    reset: () => genericPaneRef.current?.reset(),
  }));

  const items = useMemo(
    () => [
      {
        key: 'calendarEnabled',
        label: t('interviewsPane.calendarEnabled') as string,
        description: t('interviewsPane.calendarEnabledDescription') as string,
        value: account?.calendarEnabled ?? false,
        type: 'boolean' as const,
      },
      {
        key: 'adhocInterviewEnabled',
        label: t('interviewsPane.adhocInterviewEnabled') as string,
        description: t('interviewsPane.adhocInterviewEnabledDescription') as string,
        value: account?.configuration?.adhocInterviewEnabled ?? false,
        type: 'boolean' as const,
      },
      {
        key: 'isShiftIntersectable',
        label: t('interviewsPane.isShiftIntersectable') as string,
        description: t('interviewsPane.isShiftIntersectableDescription') as string,
        value: account?.configuration?.isShiftIntersectable ?? false,
        type: 'boolean' as const,
      },
    ],
    [account, t],
  );

  return (
    <GenericSettingsPane ref={genericPaneRef} onSave={onSave} setDirty={setDirty} showInlineActions={showActions} items={items} />
  );
});
